import React from "react";
import { Table, Button, Space, Popconfirm } from "antd";

const FCTable = ({ data, loading, onEdit, onDelete }) => {

  const columns = [
    {
      title: "Food Category",
      dataIndex: "name"
    },
     {
      title: "Action",
      render: (_, record) => (
        <Space>
          <Button type="link" onClick={() => onEdit(record)}>
            Edit
          </Button>

          <Popconfirm
            title="Delete menu?"
            onConfirm={() => onDelete(record.id)}
          >
            <Button danger type="link">
              Delete
            </Button>
          </Popconfirm>
        </Space>
      )
    }
  ];

  return (
    <Table
      rowKey="id"
      columns={columns}
      dataSource={data}
      loading={loading}
    />
  );
};

export default FCTable;